var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.36.832A1.155 1.155 0 0 0 .888 2.35c.878 2.278 1.947 4.537 2.45 5.573a1.84 1.84 0 0 0 1.019.92L7.483 10l-3.126 1.158a1.84 1.84 0 0 0-1.018.919c-.504 1.036-1.573 3.295-2.451 5.573a1.155 1.155 0 0 0 1.472 1.518c3.216-1.116 10-3.75 15.84-7.883a1.568 1.568 0 0 0 0-2.57C12.36 4.582 5.577 1.948 2.36.832Z",
  fill: "#3A434A"
})));
export default SvgWebappSend;